import moment from 'moment';
import React, { Component } from 'react'
import { Datos_Empresa, development } from "../../../libs/utils/Const";

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

class ReturnCNote extends Component {

    DocTimeFormat = (docTime) => {
        let time = (docTime || '').toString();

        if (time.length > 2) {
            let position = time.length - 2;
            time = time.slice(0, position) + ":" + time.slice(position, time.length)
        } else {
            time = `00:${time}`;
        }

        return time;
    }

    render() {
        const { DocsToPrint, ReportsModel } = this.props;
        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development ? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br />{/*<strong>{"InfoByFolio ? InfoByFolio.folio : ''"}</strong>*/}</p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE VENTAS ({ReportsModel.SucursalName ? ReportsModel.SucursalName : 'Sin sucursal'})</strong></h5>
                            </div>
                            <div className="col-3">
                                <p>{Datos_Empresa.Calle} #{Datos_Empresa.Numero} <br />COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}</p>
                            </div>
                        </div>

                        {/* DEVOLUCIONES */}
                        {ReportsModel.checkReturn && DocsToPrint[0].headerReturns.length > 0 &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Devoluciones</strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left">Cod. Creador </th>
                                                <th className="text-left"> Folio Counter </th>
                                                <th className="text-left"> Folio SAP </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-left">Cliente</th>
                                                <th className="text-right  pr-3">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DocsToPrint[0].headerReturns.map((element, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{element.Creator || 'SN/Código'}</td>
                                                         <td className="text-left">{element.NumAtCard || ''}</td>
                                                        <td className="text-left">{element.DocNum || ''}</td>
                                                        <td className="text-center">{moment(element.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">Devolución</td>
                                                        <td className="text-left">{element.SeriesName}</td>
                                                        <td className="text-left">{element.CardName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(element.DocTotal)}</td>
                                                    </tr>
                                                );
                                            })}

                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="6"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalReturns)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                        
                        {/* NOTAS DE CREDITO */}
                        {ReportsModel.checkCreditNote && DocsToPrint[0].headerCreditNotes.length > 0 &&
                            <div className='row mt-5' style={{ paddingRight: "15px" }}>
                                <div className='col-6 text-left'>
                                    <h6><strong>Notas de Crédito </strong></h6>
                                </div>
                                <div className='col-6 text-right'>
                                    <h6>Del {moment(ReportsModel.InitialDate).utc().format('MM/DD/YYYY')} al {moment(ReportsModel.FinalDate).utc().format('MM/DD/YYYY')}</h6>
                                </div>
                                <div className='col-12'>
                                    <table>
                                        <thead style={{ border: "solid 1px" }}>
                                            <tr>
                                                <th className="text-left">Cod. Creador </th>
                                                <th className="text-left"> Folio Counter </th>
                                                <th className="text-left"> Folio SAP </th>
                                                <th className="text-center">Fecha</th>
                                                <th className="text-center">Tipo Doc</th>
                                                <th className="text-left">Serie</th>
                                                <th className="text-left">Cliente</th>
                                                <th className="text-right  pr-3">Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {DocsToPrint[0].headerCreditNotes.map((element, index) => {
                                                return (
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-left">{element.Creator || 'SN/Código'}</td>
                                                         <td className="text-left">{element.NumAtCard || ''}</td>
                                                        <td className="text-left">{element.DocNum || ''}</td>
                                                        <td className="text-center">{moment(element.DocDate).utc().format('MM/DD/YYYY')}</td>
                                                        <td className="text-center">Nota de Crédito</td>
                                                        <td className="text-left">{element.SeriesName}</td>
                                                        <td className="text-left">{element.CardName}</td>
                                                        <td className="text-right pr-3">{formatNumber.new(element.DocTotal)}</td>
                                                    </tr>
                                                );
                                            })}

                                            <br />

                                            <tr style={{ borderTop: "solid 1px" }}>
                                                <td colspan="6"></td>
                                                <td className="text-right"><strong>Total: </strong></td>
                                                <td className="text-right"><strong>{formatNumber.new(DocsToPrint[0].SumTotalCreditNotes)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </td></tr></table>
            </>
        )
    }
}

export default ReturnCNote